import React, { useState } from "react";
import "../styles.css";
import Header from "./faqs/Header";
import FAQ from "./faqs/RawFAQs";
import Box from "@mui/material/Box";

export default function Faqs() {
  const [faqs, setFaqs] = useState([
    {
      question: "What is a Buukipa System?",
      answer:
        "Buukipa System is a computer application aimed at revolutionising book keeping for entities.",
      open: true,
    },
    {
      question: "How does the Buukipa System work?",
      answer:
        "The system has a Business Admin Dashboard, Tenant Admin Dashboard and a Worker mobile application. The worker logs into their app, then starts a job. The Tenant whose owns the worker gets a notification alert and are able to see jobs progress on their dashboard. Once the job gets started, they are able to monitor them until they get completed, and in case of any issue, they are automatically notfied.",
      open: false,
    },
    {
      question: "How does one get onboarded onto the system?",
      answer:
        "As a tenant, the business admin creates your account then send you an alert with the login credentials. You therefore login to the tenant dashboard. Upon successful first time login, you will requested to change your password. \nAs a worker, the tenant admin creates your account, you then go the playstore, download the app and login. Upon successful first time login, you will be prompted to change your password.",
      open: false,
    },
    {
      question: "What if I'm not a tenant?",
      answer:
        "Only business admins, tenant and workers can access the application",
      open: false,
    },
    {
      question: "Does the application track my location?",
      answer: "No, Buukipa does not track your location",
      open: false,
    },
    {
      question: "What happens if I don't receive the account created alert?",
      answer: "Just ask the system admin, they will be able to assist",
      open: false,
    },
    {
      question: "Can I opt out of the application?",
      answer: "Yes, upon request to the admin",
      open: false,
    },
  ]);

  const toggleFAQ = (index) => {
    setFaqs(
      faqs.map((faq, i) => {
        if (i === index) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }

        return faq;
      })
    );
  };

  return (
    <>
      <Box height={60} />
      <div className="App">
        <Header />
        <div className="faqs">
          {faqs.map((faq, index) => (
            <FAQ faq={faq} index={index} key={index} toggleFAQ={toggleFAQ} />
          ))}
        </div>
      </div>
    </>
  );
}
